import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SEO from "../components/SEO";

const AuthSuccess = () => {
  const { login } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");

    if (error) {
      navigate("/login?error=oauth_failed");
      return;
    }

    if (token) {
      localStorage.setItem("accessToken", token);

      // Also store refresh token if available
      const refreshToken = searchParams.get("refreshToken");
      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
      }

      // Simulate fetching user data or use token
      const userData = {
        id: "authenticated_user",
        name: "Authenticated User",
        email: "user@example.com",
        isAuthenticated: true,
      };

      login(userData);

      navigate("/");
    } else {
      navigate("/login");
    }
  }, [searchParams, navigate, login]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "1.2rem",
      }}
    >
      <SEO
        title="Authentication Successful - Grad4Grad"
        description="You have been successfully authenticated. Redirecting to your dashboard..."
        keywords="authentication success, login successful, grad4grad login"
        image="https://grad4grad.com/logo512.png"
        url="https://grad4grad.com/auth-success"
        type="website"
      />
      <div>Processing authentication...</div>
    </div>
  );
};

export default AuthSuccess;
